"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.schedule.date': 'Data publikacji',
    'socialMediaPlan.schedule.time': 'Godzina',
    'socialMediaPlan.schedule.summary': 'Podsumowanie posta',
    'socialMediaPlan.schedule.draftTitle': 'Wersja robocza',
    'socialMediaPlan.schedule.draftDesc': 'Zapisz jako wersję roboczą',
    'socialMediaPlan.schedule.reviewTitle': 'Do przeglądu',
    'socialMediaPlan.schedule.reviewDesc': 'Poproś o przegląd',
    'socialMediaPlan.schedule.scheduledTitle': 'Zaplanowane',
    'socialMediaPlan.schedule.scheduledDesc': 'Zaplanuj na później',
    'socialMediaPlan.schedule.publishedTitle': 'Opublikowane',
    'socialMediaPlan.schedule.publishedDesc': 'Opublikuj teraz',
};
